import { TMixpanelProperties } from '@aqx-core/common/mixpanel/types';
import { authenticationService } from '@aqx-core/common/services/auth';

import { EMixpanelProperties } from '../../types';

class UserHelper {
  public createUserAccountProperties = (): TMixpanelProperties => {
    const { selectedTradingAccountDetails, selectedTradingAccountBalances } = authenticationService.context;
    const { metatraderId } = selectedTradingAccountDetails || {};
    const { balance, equity, profitLoss, marginLevel } = selectedTradingAccountBalances || {};

    return {
      [EMixpanelProperties.METATRADER_ID]: metatraderId,
      [EMixpanelProperties.EQUITY]: equity || 0,
      [EMixpanelProperties.ACCOUNT_BALANCE]: balance || 0,
      [EMixpanelProperties.REALISE_PROFIT_LOSS]: profitLoss || 0,
      [EMixpanelProperties.MARGIN_LEVEL]: marginLevel || 0
    };
  };
}

const userHelper = new UserHelper();
export default userHelper;
